import CustomerActionTypes from './customer.types';

const INITIAL_STATE = {
  currentInformationType: null,
  currentCustomerInfo: null
};

const customerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CustomerActionTypes.SET_CURRENT_INFORMATION_TYPE:
      return {
        ...state,
        currentInformationType: action.payload
      };
    case CustomerActionTypes.SET_CURRENT_CUSTOMER_INFO:
      return {
        ...state,
        currentCustomerInfo: action.payload
      };
    case CustomerActionTypes.SET_HAS_CD_DEFAULT_INFO:
      return {
        ...state,
        hasCDDefaultInfo: action.payload
      };
    default:
      return state;
  }
};

export default customerReducer;
